
document.addEventListener('DOMContentLoaded', () => {
  const yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  const tabs = document.querySelectorAll('.phase-tab');
  const panels = document.querySelectorAll('.phase-panel');
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('active'));
      panels.forEach((p) => p.classList.remove('active'));
      tab.classList.add('active');
      const target = document.getElementById(tab.dataset.target);
      if (target) target.classList.add('active');
    });
  });

  const checklists = document.querySelectorAll('.checklist');
  checklists.forEach((list) => {
    const boxes = list.querySelectorAll('input[type="checkbox"]');
    const resultEl = list.parentElement.querySelector('[data-check-score]');
    if (!boxes.length || !resultEl) return;
    const total = boxes.length;
    const update = () => {
      const checked = list.querySelectorAll('input[type="checkbox"]:checked').length;
      resultEl.textContent = `${checked} / ${total}`;
    };
    boxes.forEach((b) => b.addEventListener('change', update));
    update();
  });

  // Kontaktformular: ausgewaehlte Themen in ein einzelnes Feld schreiben.
  // Shopifys Kontaktformular akzeptiert keine Array-Felder (contact[..][]),
  // daher sammeln wir die Checkbox-Werte in ein verstecktes contact[Thema]-Feld.
  const themaField = document.getElementById('ThemaField');
  const topicBoxes = document.querySelectorAll('.js-topic');
  if (themaField && topicBoxes.length) {
    const syncTopics = () => {
      const chosen = Array.from(topicBoxes)
        .filter((b) => b.checked)
        .map((b) => b.value);
      themaField.value = chosen.join(', ');
    };
    topicBoxes.forEach((b) => b.addEventListener('change', syncTopics));
    syncTopics();
  }
});
